export const FormatNumberInput = (number: string) => {
    return number ? number.replace(",", ".") : "";
};
